module.exports = __webpack_public_path__ + "static/15_08-0458ad-25c1ac207d78757ab8cf87d6145962e5.png";